import { CostCentersValueObjectsCostCenterStatusEnum } from 'generated/resources/graphql'

export const COST_CENTER_STATUS: Record<
  CostCentersValueObjectsCostCenterStatusEnum,
  CostCentersValueObjectsCostCenterStatusEnum
> = {
  active: 'active',
  inactive: 'inactive',
} as const
